module.exports = __webpack_public_path__ + "static/media/bg2@2x.62135c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/bg2@2x.png
// module id = 1052
// module chunks = 0